import {Component, input, output} from '@angular/core';
import {NgxEchartsDirective} from 'ngx-echarts';
import {ECElementEvent, EChartsOption} from 'echarts';

@Component({
  selector: 'mkad-chart-bar',
  standalone: true,
  imports: [
    NgxEchartsDirective,
  ],
  template: `
    <div echarts
         id="status-device-chart" class="h-fit flex align-items-center" (chartClick)="onClickChart($event)"
         [initOpts]="{
            renderer: 'svg',
              width: 'auto',
              height: '24'
            }"
         [options]="dataChart()">
    </div>
  `,
})
export class MkadChartBarComponent {
  readonly dataChart = input.required<EChartsOption>();
  readonly clickChart = output<ECElementEvent>();

  /**
   * @description
   * Method that responds to the click on the graphic
   * @param event option config references
   */
  onClickChart(event: ECElementEvent) {
    if (event) {
      this.clickChart.emit(event);
    }
  }

}
